import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const AdCreation = ({ numAds }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Ad creation') }}>
      <Text>{`${numAds} ${numAds === 1 ? i18n.getString(_TL_('Ad')) : i18n.getString(_TL_('Ads'))}`}</Text>
    </PropertyRow>
  );
};

AdCreation.propTypes = {
  numAds: PropTypes.number.isRequired,
};
